import classNames from 'classnames';
import { Icon } from 'palette/Icon';
import { storeSelectId } from './constants/storeSelect';
import './styles/CurrentStoreIndicator.scss';

export function CurrentStoreIndicator({ customClass, onClick }) {
    return (
        // eslint-disable-next-line jsx-a11y/no-static-element-interactions, jsx-a11y/click-events-have-key-events
        <div
            className={classNames('current-store-indicator', customClass)}
            data-uuid={storeSelectId}
            onClick={onClick}
        >
            <Icon
                name={`flag_${App.Config.store}`}
                size="x-small"
            />
            <Icon
                name="palette_chevron_down"
            />
        </div>
    );
}
